<template>
  <div class="bet-row">
    <tr class="border_bottom border-double">
      <td
        class="pl-1 h3"
      >
        <i
          class="result-row__icon n-i"
          :class="[`n-i-live-${bet.idSport}`, `color-sport-${bet.idSport}`]"
        />
      </td>

      <td
        class="text-warning"
      >{{ bet.matchDateTimeUTC | time("YYYY-MM-DD HH:mm") }}</td>

      <td>
        <span
          v-if="betBanker && isSystem"
          class="bet-banker">{{ betBanker }}</span>
        {{ bet.matchName }}
      </td>
      <td>{{ bet.bet.betDisplayName }}</td>
      <td>{{ odd }}</td>
      <td>{{ betPick }}</td>

      <td
        v-for="(result, index) in filterResults(bet.results)"
        :key="index"
      >{{ result.matchResultValue }}</td>

      <td
        v-if="bet.results.length == 0"
      >-</td>

      <td>
        <i
          class="n-i result-row__icon"
          :class="[`n-i-${statusIcons[bet.status]}`, `status-${bet.status}`]"
        />
      </td>

      <td
        v-if="fullResultsEnabled"
        class="show-result-wrapper-icon"
        @click="showResults = !showResults"
      >
        <i
          class="n-i n-i-arrow-right result-row__icon"
          :class="{ 'n-i-arrow-up-a' : showResults }"
        />
      </td>
    </tr>

    <tr
      v-if="showResults"
      class="border_bottom border-double"
    >
      <td
        class="final-results-wrapper"
        colspan="9"
      >
        <div>
          <span class="period-name full-result-name">{{ getTranslation('full_results') }}</span>
          <div class="results-period-wrapper">
            <div
              class="result-period"
              colspan="1"
              v-for="(result, index) in bet.finalResults"
              :key="index"
            >
              <span class="period-name">{{ result.providerResultId }}</span>
              <span class="period-value">{{ result.matchResultValue }}</span>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </div>
</template>

<script>
export default {
  name: 'BetRow',
  props: {
    bet: {
      type: Object,
      required: true,
      default: () => {},
    },
    isSystem: {
      type: Boolean,
      required: true,
      default: false,
    },
    odd: {
      type: String,
      required: true,
    },
    fullResultsEnabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isOperator: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      showResults: false,
      statusIcons: {
        CLOSED: 'close',
        LOST: 'close',
        CANCELLED: 'close',
        REJECTED: 'close',
        WON: 'check',
        PAYEDOUT: 'check',
        OPEN: 'clock',
        IN_PLAY: 'play',
        10: 'check',
        15: 'close',
        20: 'check',
        5: 'clock',
      },
    };
  },
  computed: {
    betPick() {
      const displaySpecialValue = this.bet.bet.betType === 'PLAYER_PROPS_AT_LEAST';
      const outcomeName = this.bet.betOutcome.betOutcomeDisplayName;

      if (!displaySpecialValue) return outcomeName;

      return `${outcomeName} (${this.bet.specialValue})`;
    },
    betBanker() {
      return parseInt(this.bet.ticketBetBank, 10) ? this.getTranslation('sportsbook.banker_label') : '';
    },
  },
  methods: {
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    filterResults(results) {
      return results.filter(result => result.providerResultId === 'FT').slice(0, 1) || [];
    },
  },
};
</script>
